import template from './template.html'

angular
  .module('contabilidad.asociarfacturas')
  .component('contabilidadAsociarfacturasListaItem', {
    bindings: {
      data: '<',
      onDelete: '&',
    },
    template,
    controller: Controller,
  })

Controller.$inject = ['$q', 'ContabilidasAsociarFacturas']

function Controller ($q, ContabilidasAsociarFacturas) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.confirmarEliminar = confirmarEliminar

  function $onInit () {
    $ctrl.eliminar = false
  }

  function confirmarEliminar () {
    $ctrl.onDelete()
    $ctrl.eliminar = false
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/asociarfacturas/components/lista/item/component.js